import {
  SambiLoginClient,
  PrescriptionClient,
  ConsentClient,
  PatientClient,
  DataLockClient,
  MedicationListInfoClient,
  ServiceWindowClient,
} from '@sekoia/shared/requests/nswagClients/NLLClient';

export class NLLContextClient {
  private _patientClient: PatientClient | undefined;
  public get patientClient(): PatientClient {
    if (!this._patientClient) {
      this._patientClient = new PatientClient();
    }
    return this._patientClient;
  }

  private _consentClient: ConsentClient | undefined;
  public get consentClient(): ConsentClient {
    if (!this._consentClient) {
      this._consentClient = new ConsentClient();
    }
    return this._consentClient;
  }

  private _sambiLoginClient: SambiLoginClient | undefined;
  public get sambiLoginClient(): SambiLoginClient {
    if (!this._sambiLoginClient) {
      this._sambiLoginClient = new SambiLoginClient();
    }
    return this._sambiLoginClient;
  }

  private _prescriptionClient: PrescriptionClient | undefined;
  public get prescriptionClient(): PrescriptionClient {
    if (!this._prescriptionClient) {
      this._prescriptionClient = new PrescriptionClient();
    }
    return this._prescriptionClient;
  }

  private _dataLockClient: DataLockClient | undefined;
  public get dataLockClient(): DataLockClient {
    if (!this._dataLockClient) {
      this._dataLockClient = new DataLockClient();
    }
    return this._dataLockClient;
  }

  private _medicationListInfoClient: MedicationListInfoClient | undefined;
  public get medicationListInfoClient(): MedicationListInfoClient {
    if (!this._medicationListInfoClient) {
      this._medicationListInfoClient = new MedicationListInfoClient();
    }
    return this._medicationListInfoClient;
  }

  private _serviceWindowClient: ServiceWindowClient | undefined;
  public get serviceWindowClient(): ServiceWindowClient {
    if (!this._serviceWindowClient) {
      this._serviceWindowClient = new ServiceWindowClient();
    }
    return this._serviceWindowClient;
  }
}
